export const permissionsPreviewWrapper = `relative flex flex-col md:flex-row md:h-full flex-wrap justify-evenly md:justify-center gap-2 md:gap-8`
export const permissionsPreviewTitle = `w-full text-center`
export const permissionsPreviewContentWrapper = `w-full flex flex-wrap`
export const permissionsPreviewContent = `flex flex-col w-full md:w-4/12 gap-2 gap-2 md:gap-8 pb-0  justify-center`

export const permissionsSteps = `mb-6 rounded-3xl p-4`
export const permissionsMainWrapper = `flex flex-col w-full p-2 md:p-0`
